export default __webpack_public_path__ + "static/media/calendar.4759525d.svg";